import { combineReducers } from 'redux';

export function error(state = null, action) {
  switch (action.type) {
    case 'SCHEDULE_INVOICE_CHANGE_ERROR':
      return action.error;

    case 'SCHEDULE_INVOICE_CHANGE_RESET':
      return null;

    default:
      return state;
  }
}

export function loading(state = false, action) {
  switch (action.type) {
    case 'SCHEDULE_INVOICE_CHANGE_LOADING':
      return action.loading;

    case 'SCHEDULE_INVOICE_CHANGE_RESET':
      return false;

    default:
      return state;
  }
}

export function changed(state = null, action) {
  switch (action.type) {
    case 'SCHEDULE_INVOICE_CHANGE_SUCCESS':
      return action.changed;

    case 'SCHEDULE_INVOICE_CHANGE_RESET':
      return null;

    default:
      return state;
  }
}

export default combineReducers({
  error, loading, changed,
});
